import React, { useMemo } from 'react';
import classNames from 'classnames';
import { useIntl } from 'umi';
import { Button, Icon } from 'tea-component';

import type {
  IYamlWorkflowRowState,
  TYamlWorkflowPhase,
} from '../../../types';

interface ITestActionBarProps {
  testPhase: TYamlWorkflowPhase;
  rows: IYamlWorkflowRowState[];
  testRequestLoading: boolean;
  testButtonDisabled: boolean;
  onRunTests: () => void;
}

/**
 * Step4 测试状态文案 +「执行全部」/「重新测试」按钮。
 */
const TestActionBar: React.FC<ITestActionBarProps> = ({
  testPhase,
  rows,
  testRequestLoading,
  testButtonDisabled,
  onRunTests,
}) => {
  const { formatMessage } = useIntl();

  const statusText = useMemo(() => {
    switch (testPhase) {
      case 'idle':
        return formatMessage({ id: 'dbl_model_agent_step4_test_status_idle' });
      case 'running':
        return formatMessage({ id: 'dbl_model_agent_step4_test_status_running' });
      case 'passed':
        return formatMessage({ id: 'dbl_model_agent_step4_test_status_passed' });
      case 'failed':
        return formatMessage({ id: 'dbl_model_agent_step4_test_status_failed' });
      default:
        return '';
    }
  }, [formatMessage, testPhase]);

  const showExecuteAll =
    testPhase === 'idle' && rows.every((r) => r.status === 'pending');

  return (
    <div className="dbl-model-agent-create-step-test-publish__test-bar">
      <div className="dbl-model-agent-create-step-test-publish__test-bar-left">
        <strong className="dbl-model-agent-create-step-test-publish__test-bar-label">
          {formatMessage({ id: 'dbl_model_agent_step4_test_bar_label' })}
        </strong>
        <strong
          className={classNames(
            'dbl-model-agent-create-step-test-publish__test-bar-state',
            `is-${testPhase}`,
          )}
        >
          {statusText}
        </strong>
      </div>
      <div className="dbl-model-agent-create-step-test-publish__test-bar-actions">
        {showExecuteAll ? (
          <Button
            type="primary"
            disabled={testButtonDisabled}
            onClick={() => {
              void onRunTests();
            }}
          >
            {testRequestLoading ? (
              <>
                <Icon
                  className="dbl-model-agent-create-step-test-publish__btn-loading-icon"
                  type="loading"
                />
                {formatMessage({
                  id: 'dbl_model_management_create_model_testing',
                })}
              </>
            ) : (
              formatMessage({ id: 'dbl_model_agent_step4_run_all_tests' })
            )}
          </Button>
        ) : (
          <Button
            type="weak"
            disabled={testButtonDisabled}
            onClick={() => {
              void onRunTests();
            }}
          >
            {testRequestLoading ? (
              <>
                <Icon
                  className="dbl-model-agent-create-step-test-publish__btn-loading-icon"
                  type="loading"
                />
                {formatMessage({
                  id: 'dbl_model_management_create_model_testing',
                })}
              </>
            ) : (
              formatMessage({ id: 'dbl_model_agent_step4_retest' })
            )}
          </Button>
        )}
      </div>
    </div>
  );
};

export default TestActionBar;
